import React from 'react';
import { StyledMessage, StyledBadge } from './index.styles.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const FormMessage = ({ text, id, variant, className, disabled, margin, ...rest }) => {
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    return (React.createElement(StyledMessage, { ...a11yProps, ...dataProps, variant: variant, className: className, id: id, disabled: disabled, margin: margin },
        variant === 'error' && React.createElement(StyledBadge, { semanticShape: "negative" }),
        text));
};
//# sourceMappingURL=index.js.map